import { Component, OnInit } from '@angular/core';
import { TubeSearchService } from './tube-search.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { Carrier } from '../carrier/carrier';
import { CarrierUtility } from '../utils/carrier-utility';
import { ErrorHandler } from "../utils/error-handler"
import { MessagesService } from '../messages/messages.service';
import { PrintRequest } from '../carrier/print-request';
import { saveAs as saveByFileSaver } from "file-saver";
/* 
 * @description: This component represents Tube Search module in GUI
 */
@Component({
  selector: 'app-tube-search',
  templateUrl: './tube-search.component.html',
  styleUrls: ['./tube-search.component.css']
})
export class TubeSearchComponent implements OnInit {

  carrierUtil: CarrierUtility = new CarrierUtility();
  tubeCarriers: Carrier[];
  selectedLab: SelectableLab;
  totalRecords: number = 0;
  pageIndex: number = 0;
  tubeBarcode: string;
  selectedCarrier: Carrier;
  display: boolean;
  filterBarcode: string;
  carrierLoading: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  blocked: boolean = false;
  hasToggle: boolean = false;
  isCarrier = true;

  /**
   * @constructor
   * @param _carrierSearch 
   * @param globals
   * @param _messagesService 
   */
  constructor(private _tubeSearchService: TubeSearchService, private _messagesService: MessagesService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
  }

  ngOnInit() {
    this.display = false;
  }

  /**
   * @function
   * @description: This method is accessed from GUI when enter is pressed from barcode filter
   * Search by tube barcode to invoke, this method gets total count of matched tube carriers and
   * fetches first 100 records of the list as part of lazy loading
  */
  searchTubeCarriers() {
    if (this.tubeBarcode != undefined && this.tubeBarcode != null && this.tubeBarcode != "") {
      this.tubeBarcode = this.tubeBarcode.trim();
      // allow the tube barcode with length of minmum 4 characters
      if (this.tubeBarcode.length < 4) {
        this.totalRecords = 0
        this.tubeCarriers = [];
        return;
      }

      this.pageIndex = 0;
      this.totalRecords = 0
      this.carrierLoading = true;
      this._tubeSearchService.getTubeCarriersCount(this.tubeBarcode).subscribe(
        results => {
          if (!results) {
            this.carrierLoading = false;
            return;
          }
          console.log("tube carriers Count:", results.data);
          this.totalRecords = results.data;
          this.carrierLoading = false;

        }
      )

      this._tubeSearchService.getTubeCarriers(this.pageIndex, this.tubeBarcode).subscribe(
        results => {
          if (!results) {
            this.carrierLoading = false;
            return;
          }
          console.log("Tube Search Records:", results.data);
          this.filterBarcode = this.tubeBarcode;
          this.tubeCarriers = results.data;
          this.carrierLoading = false;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
          this.carrierLoading = false;
        }
      );
      this.pageIndex = this.pageIndex + 1;
    }
    else {
      this.totalRecords = 0
      this.tubeCarriers = [];
    }
  }

  /**
   * @function
   * @description: This method is accessed from GUI when scrolled down on the data grid
   * fetches next 100 records every time scrolled to bottom of the grid, load fetches till
   *  total count of matched records are reached
  */
  loadOnScroll() {
    if (this.tubeBarcode != undefined && this.tubeBarcode != null && this.tubeBarcode != ""
      && this.tubeCarriers.length < this.totalRecords) {

      this.tubeBarcode = this.tubeBarcode.trim();
      // allow the tube barcode with length of minmum 4 characters
      if (this.tubeBarcode.length < 4) {
        return;
      }
      this.carrierLoading = true;
      this._tubeSearchService.getTubeCarriers(this.pageIndex, this.tubeBarcode).subscribe(
        results => {
          if (!results) {
            this.carrierLoading = false;
            return;
          }
          console.log("Tube Search Records:", results.data);
          this.filterBarcode = this.tubeBarcode;
          this.tubeCarriers = ((this.tubeCarriers != undefined) ? this.tubeCarriers.concat(results.data) : results.data);
          this.carrierLoading = false;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
          this.carrierLoading = false;
        }
      );
      this.pageIndex = this.pageIndex + 1;
    }
  }

  /**
     * @function
     * @param carrier 
     * @description converts State enum to string.
    */
  getStateAsString(carrier: Carrier): string {
    return this.carrierUtil.getStateAsString(carrier);
  }

  /**
     * @function
     * @param carrier 
     * @description This method is responsible for showing Carrier Overview popup while carrier barcode
     * is clicked in filtered results.
    */
  showCarrierOverview(carrier: Carrier) {
    this.selectedCarrier = carrier;
    this.display = true;
  }

  //Carrier Grid changes in Search
  isButtonDisabled(carrier: Carrier) {
    let isWIP = this.getStateAsString(carrier) === "WIP";
    return isWIP;
  }

  onReExport(carrier: Carrier) {
    console.log("onReExport needs to be implemented" + carrier);
    this._tubeSearchService.reExport(this.selectedCarrier).subscribe(
      result => {
        if (!result) {
          return;
        }
        let controllerFileContent = result.sequencerControllerFileContent;
        let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
        let fileName: string = this.selectedCarrier.barcode + '.txt';
        saveByFileSaver(blob, fileName);
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded ABI Sequencer file' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  onReprint(carrier: Carrier) {
    console.log("onReprint needs to be implemented");

    let prinetreq: PrintRequest = new PrintRequest();
    prinetreq.barCode.push(this.selectedCarrier.barcode);
    prinetreq.lab = this.selectedCarrier.lab;
    this._tubeSearchService.reprintLabel(prinetreq).subscribe(
      result => {
        if (!result) {
          return;
        }
        this._messagesService.addSuccessMessage({ severity: 'success', summary: result.data, detail: result.data });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }



}
